<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <i-input
          prefix="ios-search"
          placeholder="输入查询条件"
          v-model="search.name"
          style="width: auto"
        />
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="columns" :data="data"></i-table>
      <Page
        :total="total"
        show-sizer
        @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)"
        style="text-align:right;margin-top: 1em"
      />
      <Spin fix v-show="tableLoad"></Spin>
    </div>
    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="登录账号" prop="username">
          <i-input v-model="formValidate.username" placeholder="输入登录账号"></i-input>
        </FormItem>
        <FormItem label="登录密码" v-if="modal.title == '添加'" prop="password">
          <i-input v-model="formValidate.password" placeholder="输入登录密码" type="password"></i-input>
        </FormItem>
        <FormItem label="确认登录密码" v-if="modal.title == '添加'" prop="rePassword">
          <i-input v-model="formValidate.rePassword" placeholder="输入登录密码" type="password"></i-input>
        </FormItem>
        <FormItem label="用户名" prop="name">
          <i-input v-model="formValidate.name" placeholder="输入用户名"></i-input>
        </FormItem>
        <FormItem label="联系号码" prop="mobile">
          <i-input v-model="formValidate.mobile" placeholder="输入手机号"></i-input>
        </FormItem>
        <FormItem label="电子邮件" prop="mail">
          <i-input v-model="formValidate.mail" placeholder="输入电子邮箱地址"></i-input>
        </FormItem>
        <FormItem label="角色" prop="roles">
          <div v-if="roleList.length==0">
            暂无角色，请先
            <router-link to="/chome/crole">添加角色</router-link>
          </div>
          <CheckboxGroup v-model="formValidate.roles">
            <Checkbox v-for="item in roleList" :key="item.id" :label="item.id">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="是否启用" prop="enabled">
          <RadioGroup v-model="formValidate.enabled">
            <Radio label="true">是</Radio>
            <Radio label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        <!-- <FormItem label="所属公司" prop="company">
          <i-input v-model="formValidate.company" placeholder="输入所属公司"></i-input>
        </FormItem>-->
        <!-- <FormItem label="职位" prop="job">
          <i-input v-model="formValidate.job" placeholder="输入职位"></i-input>
        </FormItem>-->
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>
    <!-- 提示对话框 -->
    <alert-p
      :modalAlert="alert.show"
      title="警告提醒"
      content="确定要删除吗？"
      @cansel="alert.show=false"
      @makeSure="delData"
      :modal_loading="alert.loading"
    ></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { validate } from "../../../util/common/validate";

export default {
  data() {
    return {
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "账号",
          key: "username",
          align: "center"
        },
        {
          title: "用户名",
          key: "name",
          align: "center"
        },
        // {
        //   title: "公司",
        //   key: "company",
        //   align: "center"
        // },
        {
          title: "是否启用",
          key: "enabled",
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.enabled ? "已启用" : "未启用");
          }
        },
        {
          title: "手机号",
          key: "mobile",
          align: "center"
        },
        {
          title: "邮箱地址",
          key: "mail",
          align: "center"
        },
        {
          title: "创建时间",
          key: "createDate",
          align: "center"
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "i-button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.modal.title = "更新";
                      this.modal.show = true;
                      this.$refs.formValidate.resetFields(); // 清除验证错误
                      let roles = params.row.roles.map(value => {
                        return parseInt(value);
                      });
                      this.formValidate = {
                        company: params.row.company,
                        enabled: params.row.enabled + "",
                        job: params.row.job,
                        mobile: params.row.mobile,
                        mail: params.row.mail,
                        name: params.row.name,
                        userType: "COMPANY_MANAGER",
                        username: params.row.username,
                        uuid: params.row.uuid,
                        roles: roles,
                        id: params.row.id
                      };
                    }
                  }
                },
                "编辑"
              ),
              h(
                "i-button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.alert.id = params.row.id;
                      this.alert.show = true;
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ], // 表格列
      data: [], // 表格数据
      total: null,
      pageCurrent: 1,
      pageSize: 10,
      // 搜索条件
      search: {
        name: null
      },
      tableLoad: false, // 表格loading
      roleList: [], // 角色枚举列表
      modal: {
        // 对话框属性
        title: "添加",
        show: false
      },
      formValidate: {
        username: "",
        rePassword: "",
        password: "",
        name: "",
        mobile: "",
        mail: "",
        enabled: null,
        company: "",
        job: "",
        roles: [],
        userType: "COMPANY_MANAGER"
      }, // 表单数据
      ruleValidate: {
        username: [{ required: true, message: "不能为空", trigger: "blur" }],
        password: [{ required: true, message: "不能为空", trigger: "blur" }],
        rePassword: [
          { required: true, message: "不能为空" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("不能为空");
              } else if (this.formValidate.password != value)
                callback("两次密码不一样");
              else callback();
            }
          }
        ],
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        mobile: [
          { required: true, message: "不能为空" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("不能为空");
              } else if (!validate.phone(value)) callback("手机号格式错误");
              else callback();
            }
          }
        ],
        mail: [
          { required: true, message: "不能为空" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("不能为空");
              } else if (!validate.mail(value)) callback("电子邮件格式错误");
              else callback();
            }
          }
        ],
        enabled: [{ required: true, message: "请选择", trigger: "change" }],
        // company: [{ required: true, message: "不能为空", trigger: "blur" }],
        // job: [{ required: true, message: "不能为空", trigger: "blur" }],
        roles: [
          {
            required: true,
            message: "不能为空",
            type: "array"
          }
        ]
      }, // 表单验证

      alert: {
        // alert提示组件
        show: false,
        loading: false,
        id: ""
      }
    };
  },
  components: {
    toolbar
  },
  created() {
    this.getData(); // 获取表格数据
    this.getEnum(); // 获取角色枚举数据
  },
  methods: {
    getData() {
      // 获取表格数据
      let self = this;
      self.tableLoad = true;
      self.$api.System.getUserList(
        {
          pageCurrent: this.pageCurrent,
          pageSize: this.pageSize,
          content: self.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          let data = res.data.list;
          data.map((item, index) => {
            item.createDate = self.$timeStamp(item.createDate);
          });
          this.total = res.data.total;
          this.data = data;
          self.tableLoad = false;
          this.$Message.success("加载完成");
        }
      });
    },
    getEnum() {
      this.$api.System.getUserRoleEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.roleList = res.data.list;
        }
      });
    },
    addData() {
      // 打开添加窗口
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        company: "",
        enabled: null,
        job: "",
        mobile: "",
        mail: "",
        name: "",
        userType: "COMPANY_MANAGER",
        username: "",
        roles: []
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.System.postUserDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message ? res.message : "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    activeData() {
      // 表格操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.modal.show = false; // 关闭对话框
          this.formValidate.userType = "COMPANY_MANAGER"; // 企业管理员 默认字段
          if (this.modal.title == "添加") {
            this.$api.System.postUserAdd({ content: this.formValidate }, [
              "uuid",
              "company"
            ])
              .then(res => {
                // 添加用户接口
                if (res.code == 0) {
                  this.$Notice.success({
                    title: "添加成功",
                    desc: ""
                  });
                  this.getData();
                } else {
                  this.$Notice.warning({
                    title: "添加失败",
                    desc: res.message || "请联系管理员"
                  });
                }
              })
              .catch(err => {
                this.tableLoad = false;
              });
          } else {
            // 更新编辑数据
            this.$api.System.postUserEdit({ content: this.formValidate }, [
              "uuid",
              "company"
            ])
              .then(res => {
                // 更新用户接口
                if (res.code == 0) {
                  this.$Notice.success({
                    title: "更新成功",
                    desc: ""
                  });
                  this.getData();
                } else {
                  this.tableLoad = false;
                  this.$Notice.warning({
                    title: "更新失败",
                    desc: res.message || "请联系管理员"
                  });
                }
              })
              .catch(err => {
                this.tableLoad = false;
              });
          }
        } else {
          this.$Message.warning("检查错误提示");
        }
      });
    },
    // 页码切换
    pageCurrentChange(msg) {
      this.pageCurrent = msg;
      this.getData();
    },
    pageSizeChange(msg) {
      this.pageSize = msg;
      this.getData();
    }
  }
};
</script>